import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=a1578ea8&scoped=true&"
import script from "./Relations.vue?vue&type=script&lang=js&"
export * from "./Relations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1578ea8",
  null
  
)

export default component.exports